/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import TextInput from "../core/input/TextInput";
import AsyncButton from "../core/button/AsyncButton";
import { _EmailCreatorWrapper } from "./style";
import { _ButtonWrapper, _CustomFieldsEntry } from "../CustomFields/style";
var EmailCreator = function EmailCreator(_ref) {
  var emailSuffix = _ref.emailSuffix,
    applyBoardUserName = _ref.applyBoardUserName,
    onChangeUserName = _ref.onChangeUserName,
    onCreate = _ref.onCreate,
    applyBoardEmailDomain = _ref.applyBoardEmailDomain;
  return /*#__PURE__*/React.createElement(_EmailCreatorWrapper, null, /*#__PURE__*/React.createElement("h3", null, "Generate ApplyStudent Email"), /*#__PURE__*/React.createElement(_CustomFieldsEntry, null, /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "applyBoardUserName",
    inputValue: applyBoardUserName,
    onChange: onChangeUserName
  }), /*#__PURE__*/React.createElement("span", null, emailSuffix, "@", applyBoardEmailDomain), /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    buttonColor: "blue",
    onClick: onCreate
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "check"
  })))));
};
EmailCreator.propTypes = {
  studentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userName: PropTypes.string,
  onChangeUserName: PropTypes.func,
  onCreate: PropTypes.func
};
export default EmailCreator;